module.exports = __webpack_public_path__ + "static/media/horizontal-logo.fdb8e934.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/logo/horizontal-logo.png
// module id = 986
// module chunks = 0